
<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2>{{$t('certificates.expires_date_from_to')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.from')}}</label>
                      <el-form-item prop="expires_from">
                        <el-date-picker class="bg-white dark:bg-darkblue-900"
                          v-model="form.expires_from.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.to')}}</label>
                      <el-form-item prop="expires_to">
                        <el-date-picker class="bg-white dark:bg-darkblue-900"
                          v-model="form.expires_to.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>

            <div v-if="(role === 7 || role === 8 || role === 3)">
              <div v-if="role === 3">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.entity_name')}}</label>
                <el-form-item prop="distribuidor">
                  <base-el-select :options="distribuidores" v-model="form.distribuidor.value"
                    :option-listeners="{ select: handleSelectDistribuidor }" class="w-full" clearable filterable
                    value-key="idDistribuidor" :loading="loadingDistribuidores" />
                </el-form-item>
              </div>

              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.entity_name')}}</label>
              <el-form-item prop="empresa">
                  <base-el-select :options="clientes" v-model="form.empresa.value"
                    :option-listeners="{ select: handleSelectCliente }" class="w-full" clearable filterable
                    value-key="idCliente" :loading="loadingClientes" />
              </el-form-item>
            </div>

            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.type')}}</label>
            <el-form-item prop="tipoCert">
              <base-el-select :options="tiposCertificado" v-model="form.tipoCert.value"
                class="w-full" clearable filterable />
            </el-form-item>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
              <el-form-item prop="name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.serial_number')}}</label>
              <el-form-item prop="serial">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.serial.value"
                  maxlength="100"
                />
              </el-form-item>
            </div>

             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.in_use')}}</label>
              <el-form-item prop="enUso">
                <base-el-select :options="values" v-model="form.enUso.value"
                  class="w-full" clearable :placeholder="$t('app.filters.en_uso_yes_no')" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
// import { mapGetters } from 'vuex'

export default {
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      isOpen: this.panelOpen,
      vuexnamespace: 'certificates',
      loadingDistribuidores: false,
      loadingClientes: false,
      distribuidores: [],
      clientes: [],
      form: {
        expires_from: { label: i18n.t('certificates.expires_date_from'), value: '' },
        expires_to: { label: i18n.t('certificates.expires_date_to'), value: '' },
        name: { label: i18n.t('app.name'), value: '' },
        serial: { label: i18n.t('certificates.serial'), value: '' },
        distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        empresa: { label: i18n.t('clients.entity_name'), value: '' },
        tipoCert: { label: i18n.t('app.type'), value: '' },
        enUso: { label: i18n.t('app.in_use'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposCertificado: function () {
      const tiposCert = this.$store.getters['config/TIPOS_CERT'].filter(x => x.id !== 'usr' && x.id !== 'srl')
      tiposCert.forEach(x => {
        x.disabled = false
      })
      return tiposCert
    },
  },
  mounted: async function () {
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: { idCliente: x.idCliente, Nombre: x.Nombre } }))
      this.loadingClientes = false

      if (this.role === 3) {
        this.loadingDistribuidores = true
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataDistributors))
        }
        this.distribuidores = dataDistributors.Distribuidores.map(x => ({ label: x.Nombre, key: x.IdDistribuidor, value: { idDistribuidor: x.IdDistribuidor, Nombre: x.Nombre } }))
        this.loadingDistribuidores = false
      }
    }
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.serial.value = _temp.serial !== undefined && _temp.serial.value !== '' ? _temp.serial.value : ''
        this.form.expires_from.value = _temp.expires_from !== undefined && _temp.expires_from.value !== '' ? _temp.expires_from.value : ''
        this.form.expires_to.value = _temp.expires_to !== undefined && _temp.expires_to.value !== '' ? _temp.expires_to.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.tipoCert.value = _temp.tipoCert !== undefined && _temp.tipoCert.value !== '' ? _temp.tipoCert.value : ''
        this.form.enUso.value = _temp.enUso !== undefined && _temp.enUso.value !== '' ? _temp.enUso.value : ''
      }
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        expires_from: { label: i18n.t('certificates.expires_date_from'), value: '' },
        expires_to: { label: i18n.t('certificates.expires_date_to'), value: '' },
        name: { label: i18n.t('app.name'), value: '' },
        serial: { label: i18n.t('certificates.serial'), value: '' },
        distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        empresa: { label: i18n.t('clients.entity_name'), value: '' },
        tipoCert: { label: i18n.t('app.type'), value: '' },
        enUso: { label: i18n.t('app.in_use'), value: '' },
      }
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
